import { HoverCard, Loader } from '@mantine/core';
import { Badge } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { useGetBusinessPartnerRequestById } from 'api/queries/business-partner-requests/business-partner-requests';

type Props = {
    requestId: string;
};

export const GapiStatusHoverCard = ({ requestId }: Props) => {
    const { t } = useTranslation();
    const { data, isLoading, isError } = useGetBusinessPartnerRequestById(requestId);

    return (
        <HoverCard classNames={{ dropdown: 'absolute card' }}>
            <HoverCard.Target>
                <div className="inline-flex">
                    <Badge variant="info">{t('gapiStatus')}</Badge>
                </div>
            </HoverCard.Target>
            <HoverCard.Dropdown>
                <div className="p-sm">
                    {isLoading && <Loader size="sm" />}
                    {isError && <span className="text-text-light">{t('gapiStatusError')}</span>}
                    {data && (
                        <pre className="m-0 text-sm break-words whitespace-pre-wrap select-text">
                            {JSON.stringify(data.data, null, 4)}
                        </pre>
                    )}
                </div>
            </HoverCard.Dropdown>
        </HoverCard>
    );
};
